import { FuelIcon } from '@frete.com/fuel-react';
import LockedDriverImage from 'assets/illustrations/blocked-profile.webp';
import React, { FC } from 'react';
import { PRIVATE_PERSON } from '../constants';
import { TruckerInformationProps } from '../types';
import * as Styled from './styled';

const Picture: FC<TruckerInformationProps> = ({ person, vehicle, isLocked }) => {
  const { name, selfieUri } = person;
  const { ownerType } = vehicle;

  const avatarProps = {
    alt: `${name} avatar`,
    role: 'img',
    'aria-label': `${name} avatar`,
  };

  const renderLockedPicture = () => (
    <>
      <Styled.Avatar src={LockedDriverImage} {...avatarProps} data-testid="locked-avatar" />
      <Styled.LockIconWrapper>
        <FuelIcon name="lock" iconStyle="filled" size="micro" />
      </Styled.LockIconWrapper>
    </>
  );

  const renderSelfieAvatar = () => <Styled.Avatar src={selfieUri} {...avatarProps} data-testid="avatar" />;

  const renderDefaultAvatar = () => (
    <Styled.NoAvatar>
      <FuelIcon
        name={ownerType === PRIVATE_PERSON ? 'user-area' : 'vehicle-truck-cargo'}
        size="small"
        data-testid={`default-avatar-${ownerType === PRIVATE_PERSON ? 'person' : 'juridical'}`}
      />
    </Styled.NoAvatar>
  );

  const getTruckerPictureRenderer = () => {
    if (isLocked) return renderLockedPicture();

    return selfieUri ? renderSelfieAvatar() : renderDefaultAvatar();
  };

  return <Styled.Picture>{getTruckerPictureRenderer()}</Styled.Picture>;
};

export default Picture;
